module.exports = __webpack_public_path__ + "img/72.57445721.jpg";